export const dateFormats = {
    's': 'YYYY-MM-DD HH:mm',
    'm': 'YYYY-MM-DD HH:mm',
    'h': 'YYYY-MM-DD HH:mm',
    'd': 'YYYY-MM-DD',
    'w': 'YYYY-MM-DD',
    'M': 'YYYY-MM',
    'Q': 'YYYY-Q',
    'Y': 'YYYY',
    'y': 'YYYY'
};

